'use client';

import { History } from '@repo/types';
import { FieldResolver } from '@repo/ui/lib/utils/field-label-resolver';
import { Calendar } from 'lucide-react';
import { Separator } from '@repo/ui/components/ui/separator';
import { TravauxAbattage } from './history-travaux-sections/travaux-abattage';
import { TravauxCollet } from './history-travaux-sections/travaux-collet';
import { TravauxTronc } from './history-travaux-sections/travaux-tronc';
import { TravauxHouppier } from './history-travaux-sections/travaux-houppier';
import { TravauxDateEcheance } from './history-travaux-sections/travaux-date-echeance';
import { TravauxCommentaires } from './history-travaux-sections/travaux-commentaires';

interface HistoryTravauxContentProps {
  history: History;
  resolver: FieldResolver;
}

function formatDateOnly(dateString: string | Date | null | undefined): string {
  if (!dateString) return 'Date inconnue';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return 'Date invalide';
  }
}

export function HistoryTravauxContent({ history, resolver }: HistoryTravauxContentProps) {
  return (
    <div className="space-y-6 pt-2">
      {/* Titre avec date des travaux */}
      <div className="flex items-center gap-2 pb-3 border-b border-gray-100">
        <Calendar className="h-4 w-4 text-primary" />
        <h4 className="text-base font-semibold text-gray-900">
          Initialement prévue : {history.user_edited_date_travaux ? formatDateOnly(history.user_edited_date_travaux) : formatDateOnly(history.created_at)}
        </h4>
      </div>

      {/* Abattage */}
      <TravauxAbattage history={history} resolver={resolver} />

      <Separator className="my-4" />

      {/* Système racinaire, collet */}
      <div className="space-y-4">
        <label className="text-sm font-semibold text-gray-900 flex items-center gap-2">
          <div className="w-1 h-4 bg-primary rounded-full"></div>
          Système racinaire, collet
        </label>
        <div className="space-y-3 pl-3">
          <TravauxCollet history={history} resolver={resolver} />
          <TravauxTronc history={history} resolver={resolver} />
        </div>
      </div>

      <Separator className="my-4" />

      {/* Houppier */}
      <TravauxHouppier history={history} resolver={resolver} />

      {/* Date échéance initiale */}
      {history.date_pro_visite && (
        <>
          <Separator className="my-4" />
          <TravauxDateEcheance history={history} />
        </>
      )}

      {/* Commentaires travaux */}
      {history.travaux_commentaire && (
        <>
          <Separator className="my-4" />
          <TravauxCommentaires history={history} />
        </>
      )}
    </div>
  );
}
